/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyAfghani = createReactComponent("currency-afghani", "IconCurrencyAfghani", [
  ["path", { d: "M15 13h-3.5a3.5 3.5 0 1 1 3.5 -3.5v6.5h-7", key: "svg-0" }],
  ["path", { d: "M12 3v.01", key: "svg-1" }],
  ["path", { d: "M12 19v2", key: "svg-2" }]
]);

export { IconCurrencyAfghani as default };
//# sourceMappingURL=IconCurrencyAfghani.js.map
